<template>
    <div>
        <TopbarInternaIt /> 

        <div class="infoSale">
            <img id="ingresso" src="@/assets/ingresso.jpg" alt="Ingresso museo">
            <router-link to="/it/museo"><p class="btnLingua">Scopri il museo</p></router-link>
            <img id="assonometria" src="@/assets/assonometria.jpg" alt="Mappa 3D">
            <p id="titoloSale">Le Sale</p>
        </div>
        
        <div class="sale">
            <div class="sala">
                <router-link to="/it/sala-1">
                    <img class="salaImg" src="@/assets/sale/1-sala_I.jpg" alt="Sala 1">
                    <p class="salaDes">I</p>
                </router-link>
            </div>     
            
            <div class="sala">
                <router-link to="/it/sala-2">
                    <img class="salaImg" src="@/assets/sale/2-sala_II.jpg" alt="Sala 2">
                    <p class="salaDes">II</p>
                </router-link>
            </div>

            <div class="sala">
                <router-link to="/it/sala-3">
                    <img class="salaImg" src="@/assets/sale/3-Sala_III.jpg" alt="Sala 3">
                    <p class="salaDes">III</p>
                </router-link>
            </div>
        </div>

        <div class="sale">
            <div class="sala">
                <router-link to="/it/sala-4">
                    <img class="salaImg" src="@/assets/sale/4-Sala_IV.jpg" alt="Sala 4">
                    <p class="salaDes">IV</p>
                </router-link>
            </div>     
            
            <div class="sala">
                <router-link to="/it/sala-5">
                    <img class="salaImg" src="@/assets/sale/5-Sala_V.jpg" alt="Sala 5">
                    <p class="salaDes">V</p>
                </router-link>
            </div>

            <div class="sala">
                <router-link to="/it/sala-6">
                    <img class="salaImg" src="@/assets/sale/6-Sala_VI.jpg" alt="Sala 6">
                    <p class="salaDes">VI</p>
                </router-link>
            </div>
        </div>

        <div class="sale">
            <div class="sala">
                <router-link to="/it/sala-7">
                    <img class="salaImg" src="@/assets/sale/7-Sala_VII.jpg" alt="Sala 7">
                    <p class="salaDes">VII</p>
                </router-link>
            </div>     
            
            <div class="sala">
                <router-link to="/it/sala-8">
                    <img class="salaImg" src="@/assets/sale/8-Sala_VIII.jpg" alt="Sala 8">
                    <p class="salaDes">VIII</p>
                </router-link>
            </div>

            <div class="sala">
                <router-link to="/it/sala-9">
                    <img class="salaImg" src="@/assets/sale/9-Sala_IX.jpg" alt="Sala 9">
                    <p class="salaDes">IX</p>
                </router-link>
            </div>
        </div>

        
    </div>
</template>

<script>
    import TopbarInternaIt from '@/components/TopbarInternaIt.vue';

    export default {
        name: 'ItHome',
        components: {
            TopbarInternaIt
        }
    }
</script>